const LOCAL_API_BASE_URL = 'http://localhost:4000'
const VPS_API_BASE_URL = 'https://api.master-slova.club'

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0'])

const trimTrailingSlash = (value: string): string =>
  value.endsWith('/') ? value.slice(0, -1) : value

const getRuntimeHostname = (): string => {
  if (typeof window === 'undefined') {
    return 'localhost'
  }

  return String(window.location.hostname || '')
    .trim()
    .toLowerCase()
}

const isLocalApiUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value)
    return LOCAL_HOSTNAMES.has(parsed.hostname.toLowerCase())
  } catch {
    return false
  }
}

const resolveRuntimeDefaultApiBaseUrl = (): string => {
  const hostname = getRuntimeHostname()

  if (LOCAL_HOSTNAMES.has(hostname)) {
    return LOCAL_API_BASE_URL
  }

  return VPS_API_BASE_URL
}

export const resolveApiBaseUrl = (): string => {
  const envValue = import.meta.env.VITE_API_BASE_URL?.trim()
  const runtimeHostname = getRuntimeHostname()
  const runtimeDefault = trimTrailingSlash(resolveRuntimeDefaultApiBaseUrl())

  let source = 'runtime-hostname'
  let resolved = runtimeDefault

  if (envValue) {
    const envResolved = trimTrailingSlash(envValue)
    const runtimeIsLocal = LOCAL_HOSTNAMES.has(runtimeHostname)
    const envIsLocal = isLocalApiUrl(envResolved)

    if (!runtimeIsLocal && envIsLocal) {
      source = 'runtime-hostname (ignored local env override)'
      resolved = runtimeDefault
    } else {
      source = 'env:VITE_API_BASE_URL'
      resolved = envResolved
    }
  }

  if (typeof window !== 'undefined') {
    console.info(`[TMA] API base URL resolved to ${resolved} (${source}, host=${runtimeHostname || '-'})`)
  }

  return resolved
}
